import { gql, useMutation } from '@apollo/client';
import { useDispatch } from 'react-redux';
import type {
  TrackPlatformRequestMutation,
  TrackPlatformRequestMutationVariables,
} from '../../graphql/generated/graphqlTypes';
import UIActions from '../../ui/UIActions';

const REQUEST_INTEGRATION = gql`
  mutation trackPlatformRequest($properties: TrackProperties!) {
    track(event: REQUEST_INTEGRATION, properties: $properties)
  }
`;

const useRequestIntegrationMutation = () => {
  const dispatch = useDispatch();
  const [requestIntegration] = useMutation<
    TrackPlatformRequestMutation,
    TrackPlatformRequestMutationVariables
  >(REQUEST_INTEGRATION);

  const request = async (label: string, website: string, detail: string) => {
    const requested = await requestIntegration({
      variables: { properties: { label, website, detail } },
    });
    if (requested) {
      dispatch(
        UIActions.pushToast({
          level: 'success',
          message: 'Integration requested',
        }),
      );
      return true;
    }
    dispatch(
      UIActions.pushToast({
        level: 'error',
        message: 'Could not request integration',
      }),
    );
    return false;
  };

  return request;
};

export default useRequestIntegrationMutation;
